import { Image } from "antd";
import React, { useEffect, useState } from "react";
/** @jsxImportSource @emotion/react */
import "twin.macro";
import { isEmpty, Toast } from "../../lib/helpers/helpers";
import { ButtonLightPink, hideScrollbar } from "../../lib/styles/styleLibrary";
import { useFetchUpcomingWeddings } from "../../redux/api/WeddingAPI";
import PageTitleNavigation from "../PageTitleNavigation/PageTitleNavigation";
import { ButtonTab, ContentWrapper, WeddingDetailsWrapper } from "./component";
import DetailsHome from "./DetailsHome";
import DetailsPhoto from "./DetailsPhoto";
import DetailsStory from "./DetailsStory";

const WeddingDetails = ({
	handleBackButton = () => {
		return null;
	},
	handleJoinEvent = () => {
		return null;
	},
	details,
}) => {
	const [flow, setFlow] = useState("home");
	const [notJoined, setNotJoined] = useState(true);
	const { data: upcomingWeddings } = useFetchUpcomingWeddings();

	let result = upcomingWeddings?.weddings?.reduce((unique, o) => {
		if (!unique.some((wed) => wed.id === details.id)) {
			unique.push(o);
		}
		return unique;
	}, []);

	useEffect(() => {
		if (isEmpty(result)) {
			return;
		}

		result?.map((d) => {
			if (d.id === details.id) return setNotJoined(false);
		});

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [result]);

	console.log(details);

	return (
		<WeddingDetailsWrapper>
			<PageTitleNavigation
				handleBackButton={() => handleBackButton()}
				showBack
				tw="absolute! z-30 top-2 left-2 m-0!"
			/>
			{notJoined && (
				<ButtonLightPink
					tw="absolute! z-30 top-2 right-2 m-0!"
					onClick={() => {
						setTimeout(() => {
							handleJoinEvent(details.event_code);
						}, 250);
					}}>
					Join
				</ButtonLightPink>
			)}
			<div tw="">
				<Image
					src={
						details?.story_cover_image_url ||
						"https://www.lunapic.com/editor/premade/o-retro.gif"
					}
					width="100%"
					height="250px"
					preview={false}
				/>
			</div>

			<div
				tw="flex flex-row flex-nowrap justify-center items-center gap-4 overflow-x-scroll m-2"
				css={hideScrollbar}>
				<ButtonTab
					onClick={() => {
						setFlow("home");
					}}
					active={flow === "home" ? "active" : undefined}>
					<span tw="text-sm font-semibold">Home</span>
				</ButtonTab>
				<ButtonTab
					onClick={() => {
						setFlow("story");
					}}
					active={flow === "story" ? "active" : undefined}>
					<span tw="text-sm font-semibold">Our Story</span>
				</ButtonTab>
				<ButtonTab
					onClick={() => {
						setFlow("photo");
						!details?.is_wedding_pictures_public &&
							Toast.fire({
								icon: "warning",
								title: "Photos of this event are strictly private",
							});
					}}
					disabled={
						!details?.is_wedding_pictures_public ? true : false
					}
					active={flow === "photo" ? "active" : undefined}>
					Photos{" "}
				</ButtonTab>
			</div>

			<ContentWrapper tw="p-0 md:p-2">
				{flow === "home" && <DetailsHome details={details} />}
				{flow === "story" && <DetailsStory details={details} />}
				{flow === "photo" && <DetailsPhoto details={details} />}
			</ContentWrapper>
		</WeddingDetailsWrapper>
	);
};

export default WeddingDetails;
